import { Link, useLocation } from 'react-router-dom';

function DashboardLayout({ user, onLogout, children }) {
  const location = useLocation();

  // Mapping entre les IDs d'onglets et les noms de sections en base de données
  const allTabs = [
    { id: 'profils', label: 'Profils', path: '/admin_4Sd6c3P7/profils', section: 'profils' },
    { id: 'operateurs', label: 'Opérateurs', path: '/admin_4Sd6c3P7/operateurs', section: 'operateurs' },
    { id: 'produits', label: 'Produits', path: '/admin_4Sd6c3P7/produits', section: 'produits' },
    { id: 'codebarre', label: 'Lecteurs', path: '/admin_4Sd6c3P7/codebarre', section: 'codebarre' },
    { id: 'planning', label: 'Planning', path: '/admin_4Sd6c3P7/planning', section: 'planning' },
    { id: 'revendeurs', label: 'Revendeurs', path: '/admin_4Sd6c3P7/revendeurs', section: 'revendeurs' },
    { id: 'ffm', label: 'FFM', path: '/admin_4Sd6c3P7/ffm', section: 'ffm' },
    { id: 'stock', label: 'Stock', path: '/admin_4Sd6c3P7/stock', section: 'stock' }
  ];

  // Filtrer les onglets selon les sections autorisées du profil
  const tabs = allTabs.filter(tab => {
    // Si l'utilisateur n'a pas de sections définies, afficher tous les onglets (rétrocompatibilité)
    if (!user.sections || user.sections.length === 0) {
      return true;
    }
    // Sinon, vérifier que la section de l'onglet est dans les sections autorisées
    return user.sections.includes(tab.section);
  });

  const isActiveTab = (path) => location.pathname === path;

  return (
    <div style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {/* Barre de navigation */}
      <nav style={{
        backgroundColor: '#ffffff',
        padding: '0 30px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '2px solid #e0e5ea',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)'
      }}>
        <div style={{ 
          display: 'flex', 
          gap: '5px',
          alignItems: 'center',
          height: '70px'
        }}>
          {tabs.map(tab => (
            <Link
              key={tab.id}
              to={tab.path}
              style={{
                padding: '0 20px',
                backgroundColor: isActiveTab(tab.path) ? '#e3f2fd' : 'transparent',
                color: isActiveTab(tab.path) ? '#1aabf9' : '#6c757d',
                border: 'none',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: isActiveTab(tab.path) ? '600' : '500',
                transition: 'all 0.3s ease',
                height: '100%',
                borderBottom: isActiveTab(tab.path) ? '3px solid #1aabf9' : '3px solid transparent',
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center'
              }}
              onMouseEnter={(e) => {
                if (!isActiveTab(tab.path)) {
                  e.target.style.backgroundColor = '#f8f9fa';
                  e.target.style.color = '#1aabf9';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActiveTab(tab.path)) {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#6c757d';
                }
              }}
            >
              {tab.label}
            </Link>
          ))}
        </div>
        <div style={{ 
          display: 'flex', 
          gap: '25px', 
          alignItems: 'center' 
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            <div style={{
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              backgroundColor: '#1aabf9',
              boxShadow: '0 0 10px rgba(26, 171, 249, 0.5)'
            }}></div>
            <span style={{ 
              color: '#212529',
              fontWeight: '600',
              fontSize: '15px'
            }}>
              {user.username}
            </span>
          </div>
          <button
            onClick={onLogout}
            style={{
              padding: '10px 20px',
              backgroundColor: 'transparent',
              color: '#6c757d',
              border: '1px solid #dee2e6',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '500',
              fontSize: '14px',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f8f9fa';
              e.target.style.color = '#212529';
              e.target.style.borderColor = '#ced4da';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#6c757d';
              e.target.style.borderColor = '#dee2e6';
            }}
          >
            Déconnexion
          </button>
        </div>
      </nav>

      {/* Contenu principal */}
      <div style={{ padding: '40px' }}>
        {children}
      </div>
    </div>
  );
}

export default DashboardLayout;
